<template>
  <div>
    <div class="anchor" @click="handleClickToGenerateLink">{{ cleanFileName(document) }}</div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "S3FileGenerator",
  props: [
    "document"
  ],
  data() {
    return {
      temporaryLinkUri: ""
    }
  },
  methods: {
    ...mapActions('s3ServiceModule', [
      'fetchFile'
    ]),

    async handleClickToGenerateLink() {
      try {
        const s3Data = await this.fetchFile(this.document);
        if (s3Data && s3Data.hasOwnProperty('status') && s3Data.status === 200) {
          this.temporaryLinkUri = s3Data.data.data.url;
          window.open(this.temporaryLinkUri, "_blank");
        } else {

        }
      }
      catch (e) {

        }
    },
    cleanFileName(val) {
      if (!val) {
        return;
      }

      const newName = val.split("/").pop();
      return newName.split("-").splice(1, newName.split('-').length).join("-");
    },

  }
}
</script>